<ng-container *ngIf="show">
  <mat-icon
    fontSet="material-icons-outlined"
    class="api-field-helper__trigger mat-icon-s"
    [matTooltip]="'developerMode.fieldHelper.tooltip' | translate"
    [matMenuTriggerFor]="helperMenu"
    (click)="$event.stopPropagation()"
    data-test="apiFieldHelperTrigger"
  >build</mat-icon>

  <mat-menu #helperMenu="matMenu" class="api-field-helper__menu">
    <div class="api-field-helper__panel" (click)="$event.stopPropagation()">

      <div class="api-field-helper__request">
        <span class="api-field-helper__method">{{ catalogEntry?.method }}</span>
        <span class="api-field-helper__url">{{ url }}</span>
      </div>

      <div class="api-field-helper__row">
        <span class="overline-o2 secondary-text">{{ 'developerMode.fieldHelper.field' | translate }}</span>
        <span class="api-field-helper__field">{{ fieldPathLabel }}</span>
      </div>

      <pre class="api-field-helper__payload">{{ payload }}</pre>

      <div *ngIf="catalogEntry?.bodyFormat === 'multipart'" class="api-field-helper__note caption-c2">
        {{ 'developerMode.fieldHelper.multipart' | translate }}
      </div>

      <button mat-button class="api-field-helper__copy" (click)="copy($event)" data-test="apiFieldHelperCopy">
        <mat-icon svgIcon="copy" class="mat-icon-s"></mat-icon>
        <span>{{ (copied ? 'developerMode.fieldHelper.copied' : 'developerMode.fieldHelper.copy') | translate }}</span>
      </button>
    </div>
  </mat-menu>
</ng-container>
